export const apiRoutes = {
  api_r_user_module_comsaEnvironmental_getModuleData: {
    path: 'm/comsa-environmental/get-module-data/',
  },
  api_r_user_module_comsaEnvironmental_section_edit: {
    path: 'm/comsa-environmental/section/edit/',
  },
  api_r_user_module_comsaEnvironmental_section_delete: {
    path: 'm/comsa-environmental/section/delete/',
  },
  api_r_user_module_comsaEnvironmental_section_sheet_get: {
    path: 'm/comsa-environmental/section/sheet/get/',
  },
  api_r_user_module_comsaEnvironmental_section_sheet_edit: {
    path: 'm/comsa-environmental/section/sheet/edit/',
  },
  api_r_user_module_comsaEnvironmental_listXlsPpiReportMilestone: {
    path: 'm/comsa-environmental/list-xls-ppi-report-milestone/',
  },
  api_r_user_module_comsaEnvironmental_editXlsPpiReportMilestone: {
    path: 'm/comsa-environmental/edit-xls-ppi-report-milestone/',
  },
  api_r_user_module_comsaEnvironmental_getXlsReport: {
    path: 'm/comsa-environmental/get-xls-report/',
  },
  api_r_user_module_comsaEnvironmental_downloadXlsPpiReport: {
    path: 'm/comsa-environmental/download-xls-ppi-report/',
  },
  api_r_user_module_comsaEnvironmental_getXlsPpiReportMilestoneLink: {
    path: 'm/comsa-environmental/get-xls-ppi-report-milestone-link/',
  },
};
